import { render, staticRenderFns } from "./FullScreenSwitcher.vue?vue&type=template&id=4ea03b78"
import script from "./FullScreenSwitcher.vue?vue&type=script&lang=js"
export * from "./FullScreenSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports